import React, { useCallback } from 'react';

import { ButtonSizes } from '@rbilabs/components-library';
import { useNavigate } from 'react-router';

import { ActionButton } from 'components/action-button';
import { useLoyaltyExternalOffersEmptyStates } from 'hooks/use-loyalty-external-offers-empty-states';

import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateImage,
  EmptyStateTitle,
} from './external-offers-empty-state.styled';

export const ExternalOffersEmptyState = () => {
  const { externalOffersEmptyStates, externalOffersEmptyStatesLoading } =
    useLoyaltyExternalOffersEmptyStates();
  const navigate = useNavigate();

  const handleClick = useCallback((link: string) => {
    navigate(link);
  }, []);

  if (externalOffersEmptyStatesLoading || !externalOffersEmptyStates) {
    return null;
  }

  return (
    <EmptyState data-testid="external-offers-empty-state">
      <EmptyStateImage
        image={externalOffersEmptyStates.emptyStateImageContent?.image?.locale}
        alt=""
        objectFitContain
      />
      <EmptyStateTitle>{externalOffersEmptyStates.title?.locale}</EmptyStateTitle>
      <EmptyStateDescription>{externalOffersEmptyStates.description?.locale}</EmptyStateDescription>
      {externalOffersEmptyStates.emptyStateImageContent?.ctaButtonLink?.locale && (
        <ActionButton
          onClick={() =>
            handleClick(
              externalOffersEmptyStates.emptyStateImageContent?.ctaButtonLink?.locale as string
            )
          }
          size={ButtonSizes.LARGE}
        >
          {externalOffersEmptyStates.emptyStateImageContent?.ctaButtonText?.locale}
        </ActionButton>
      )}
    </EmptyState>
  );
};
